var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkLibrary = function SvgLinkLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.32 8.675a7.806 7.806 0 0 0-11.04 0l-1.843 1.844a3.194 3.194 0 1 1-4.518-4.517l1.845-1.844c5.543-5.544 14.53-5.544 20.074 0s5.544 14.53 0 20.075l-1.88 1.879a3.194 3.194 0 0 1-4.516-4.517l1.879-1.88a7.806 7.806 0 0 0 0-11.04m-20.956 5.399a3.194 3.194 0 0 1 0 4.517l-1.693 1.693a7.806 7.806 0 0 0 0 11.04 7.806 7.806 0 0 0 11.04 0l1.519-1.518a3.194 3.194 0 0 1 4.517 4.517l-1.518 1.519c-5.544 5.544-14.531 5.544-20.075 0s-5.544-14.531 0-20.075l1.693-1.693a3.194 3.194 0 0 1 4.517 0m16.665 3.275a3.194 3.194 0 1 0-4.518-4.518L13.477 22.866a3.194 3.194 0 0 0 4.517 4.517z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkLibrary;